import styled from '@emotion/styled'
import ImageSlider from '../../components/common/ImageSlider'
import { GREEN } from '../../constant/colors'
import { useGetShopImageSlider } from '../../services/shop/shop-query'
import { useScreen } from '../../utils/responsive-helper'
import CouponCardSlider from './CouponCardSlider'

const Layout = styled.div`
  overflow: auto;
`

const Section = styled.div`
  margin: 16px 0;
`

const Promotion = () => {
  const { isMobile } = useScreen()
  const { data: shopImageSlider } = useGetShopImageSlider()

  return (
    <Layout>
      {shopImageSlider?.content && (
        <Section>
          <ImageSlider
            dotColor={GREEN}
            imageHeight={isMobile ? 150 : 400}
            images={shopImageSlider.content}
            status="Detail"
          />
        </Section>
      )}
      <CouponCardSlider />
    </Layout>
  )
}

export default Promotion
